/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: '/dashboard',
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard",
  },
  // {
  //   url: "/chat",
  //   tag: null,
  //   tagColor: 'primary',
  //   name: "Chat",
  //   slug: "chat",
  //   icon: "MessageSquareIcon",
  //   i18n: "Chat",
  // },
  {
    url: '/categories',
    slug: 'categories',
    name: "Categories",
    icon: "LayersIcon",
    i18n: "Categories",
  },
  {
    url: null,
    name: "Questions",
    icon: "EditIcon",
    i18n: "Questions",
    submenu: [
      {
        url: '/questions/add',
        name: "Add Questions",
        slug: "questions-add",
        i18n: "AddQuestions",
      },
      {
        url: '/questions',
        name: "All Questions",
        slug: "questions-list",
        i18n: "AllQuestions",
      },
    ]
  },
  {
    url: null,
    name: "Tests",
    icon: "FileIcon",
    i18n: "Tests",
    submenu: [
      {
        url: '/tests/add',
        name: "Add Module",
        slug: "modules-add",
        i18n: "AddTests",
      },
      {
        url: '/tests',
        name: "All Tests",
        slug: "modules-list",
        i18n: "AllTests",
      },
    ]
  },
  {
    url: null,
    name: "Packages",
    icon: "ArchiveIcon",
    i18n: "Packages",
    submenu: [
      {
        url: '/packages/add',
        name: "Add Module",
        slug: "packages-add",
        i18n: "AddPackages",
      },
      {
        url: '/packages',
        name: "All Packages",
        slug: "packages-list",
        i18n: "AllPackages",
      },
    ]
  },
  {
    url: null,
    name: "Students",
    icon: "UsersIcon",
    i18n: "Students",
    submenu: [
      {
        url: '/students',
        name: "All Students",
        slug: "students-list",
        i18n: "AllStudents",
      },
      {
        url: '/students/add',
        name: "Add Student",
        slug: "students-add",
        i18n: "AddStudent",
      },
    ]
  },
  {
    url: 'banners',
    slug: 'banners',
    name: "Banners",
    icon: "CreditCardIcon",
    i18n: "Banners",
  },
  {
    url: '/settings',
    slug: 'settings',
    name: "Settings",
    icon: "SettingsIcon",
    i18n: "Settings",
  },
]

